import {
    SoundButton,
    type SoundButtonProps,
} from "../../../../common/SoundButton/SoundButton";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import "./MainPageNavButton.scss";

interface MainPageNavButtonProps extends Omit<
    SoundButtonProps,
    "children" | "aria-label" | "aria-describedby"
> {
    icon: string;
    label: string;
    isUpdated?: boolean;
    notificationLabel?: string;
}

export function MainPageNavButton({
    icon,
    label,
    isUpdated = false,
    notificationLabel,
    className,
    type = "button",
    ...buttonProps
}: MainPageNavButtonProps) {
    const { t } = useTranslation();
    const badgeId = useId();
    const notificationId = useId();
    const descriptionIds = [
        isUpdated && badgeId,
        notificationLabel && notificationId,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <SoundButton
            {...buttonProps}
            type={type}
            className={["main-page-nav-button", className]
                .filter(Boolean)
                .join(" ")}
            aria-label={label}
            aria-describedby={descriptionIds || undefined}
        >
            <img
                className="main-page-nav-button__icon"
                src={icon}
                alt=""
                draggable={false}
            />
            {notificationLabel && (
                <span
                    className={[
                        "main-page-nav-button__notification",
                        isUpdated &&
                            "main-page-nav-button__notification--with-badge",
                    ]
                        .filter(Boolean)
                        .join(" ")}
                >
                    <span
                        id={notificationId}
                        className="main-page-nav-button__notification-label"
                    >
                        {notificationLabel}
                    </span>
                </span>
            )}
            {isUpdated && (
                <span
                    id={badgeId}
                    className="main-page-nav-button__badge"
                    dir="auto"
                >
                    {t("mainPage.navigation.updatedBadge")}
                </span>
            )}
        </SoundButton>
    );
}
